import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { Col, Row } from "@intech/web-ui";
import { device } from "../../../device";

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
  align-items: baseline;
  width: 100%;
  margin-top: 16px;
`;

export const AutoColumn = styled(Col)`
  width: 100%;
  display: flex;
  @media ${device.tablet} {
    flex-direction: row;
  }
  @media not ${device.tablet} {
    flex-direction: column;
  }
`;

export const Label = styled.div`
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  @media ${device.tablet} {
    flex: 1 0 40%;
    max-width: 40%;
    text-align: right;
  }
  @media not ${device.tablet} {
    flex: 1 0 100%;
    max-width: 100%;
    text-align: left;
  }
  position: relative;
  width: 100%;
  padding: calc(0.375rem + 1px) 15px;
`;

export const Select = styled.select`
  background-image: none;
  display: block;
  width: inherit;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  word-wrap: normal;
  text-transform: none;
  margin: 0;
  font-family: inherit;
`;